import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '@components/application/modal';
import EventEmitter, { EVENT_TYPES } from '@lib/eventEmitter';
import LocationQuestion from './views/locationQuestion';
import DeliveryOptions from './views/deliveryOptions';
import DeliveryOptionsUnreachable from './views/deliveryOptionsUnreachable';
import DeliveryOptionsInvalidLocation from './views/deliveryOptionsInvalidLocation';

const DeliveryOptionsModal = ({
  stockReference,
  updateDeliveryPreferences,
  userLocation,
}) => {
  const views = {
    location: LocationQuestion,
    deliveryOptions: DeliveryOptions,
    deliveryOptionsUnreachable: DeliveryOptionsUnreachable,
    deliveryOptionsInvalidLocation: DeliveryOptionsInvalidLocation,
  };

  const [view, setView] = useState('location');
  const [location, setLocation] = useState(userLocation ? userLocation : '');

  const closeModal = (event) => {
    event.preventDefault();
    EventEmitter.emit(EVENT_TYPES.closeModal);
  };

  const DeliveryOptionsView = views[view];

  return (
    <Modal hideClose id="delivery-options-modal" setWindowHistory>
      <div className="do-wrapper">
        <div className="do-header">
          <span className="do-brand">Your delivery options</span>
          <a
            className="ac-modal__close ac-modal__close--delivery-options"
            href="#"
            onClick={closeModal}
          />
        </div>
        <div className="do-body">
          <div className="do-modal__content">
            <DeliveryOptionsView
              closeModal={closeModal}
              location={location}
              setLocation={setLocation}
              setView={setView}
              stockReference={stockReference}
              updateDeliveryPreferences={updateDeliveryPreferences}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeliveryOptionsModal;

DeliveryOptionsModal.propTypes = {
  stockReference: PropTypes.string,
  updateDeliveryPreferences: PropTypes.func,
  userLocation: PropTypes.string,
};
